import React from 'react';
import { observer } from 'mobx-react';
import { AnswerableRadioButton } from './radio-button';
import { RadioGroupInput } from '../design-system/inputs';

export default observer(
    ({
        groupId,
        radioOptions,
        onChange,
        value,
        answer,
        overwriteGlobalStyles,
        label,
    }) => {
        return (
            <RadioGroupInput
                aria-label="email"
                name="email"
                value={value}
                label={label}
            >
                {radioOptions.map((v, i) => {
                    return (
                        <AnswerableRadioButton
                            key={'radio-' + i}
                            groupId={groupId}
                            onChange={onChange}
                            groupValue={value}
                            value={v.value}
                            text={v.text}
                            answer={answer}
                            overwriteGlobalStyles={overwriteGlobalStyles}
                        />
                    );
                })}
            </RadioGroupInput>
        );
    }
);
